import BaseEntity from 'src/entities/BaseEntity';
import { EntityDescriptions } from 'src/store/entities/types';
import EntityDescription from 'src/store/entities/types/EntityDescription';

export const ALL_PRODUCT_GROUP_SLUGS = [
    'accessoires',
    'beans',
    'cateringSupplies',
    'cleaningCare',
    'coffeeTimeTabs',
    'cups',
    'fullyAutoMachine',
    'groundCoffee',
    'machines',
    'partner',
    'portaFilter',
    'specialOffers',
    'vending',
    'vendingSupplies',
    'workingMaterial',
    'abo',
    'all',
] as const;

export type ProductGroupSlug = typeof ALL_PRODUCT_GROUP_SLUGS[number];

export default class ProductGroup extends BaseEntity {
    public normalizedName: string;
    public localizedName: string;
    public slug: string;
    public imageUrl: string;

    constructor(json: any) {
        super(json);

        this.normalizedName = json.normalizedName;
        this.localizedName = json.localizedName;
        this.slug = json.slug;
        this.imageUrl = json.imageUrl;
    }

    getEntityDescription(): EntityDescription {
        return EntityDescriptions.PRODUCT_GROUP;
    }

    toString(): string {
        return `${this.normalizedName}:${this.localizedName}`;
    }
}
